import P from "../ui/p"
import Image from "next/image"
import Button from "../ui/button"
import ButtonContent from "../ui/button-content"


const NotFoundTemplate = () => {


    return (
        <>
            <Image
                src="/images/404.svg"
                alt="404"
                quality={100}
                height={193}
                width={424}
            />
            <P>Oops! Something went wrong. We&#39;re working to fix it. Please try again in a moment!</P>
        </>
    )
}
export default NotFoundTemplate